import { FC } from 'react'

import AlertsProvider from '@provider/Alerts'
import BudgetProvider from '@provider/Budget'
import ParamsCenterProvider from '@provider/Config/ParamsCenterProvider'
import DashboardProviders from '@provider/Dashboard'
import FollowUpFornecedorProvider from '@provider/FollowUpFornecedor'
import KpiProviders from '@provider/Kpi'
import MrpProviders from '@provider/Mrp'
import OptimizerConfigDefaultProvider from '@provider/Optimizer/ConfigDefaultProvider'
import OptimizerStorangeProvider from '@provider/Optimizer/OptimizerStorange'
import OtbProviders from '@provider/Otb'
import ParametrizationProvider from '@provider/Parametrization'
import SettingsProvider from '@provider/Parametrization/SettingsProvider'

import AuthProvider from './AuthProvider'
import FiltersProvider from './FiltersProvider'
import HomeProvider from './HomeProvider'
import LayoutProvider from './LayoutProvider'
import ProfileProvider from './ProfileProvider'
import SessionsProvider from './SessionsProvider'
import UserAuthProvider from './UserAuthProvider'

const SharedProvider: FC = ({ children }) => {
  return (
    <UserAuthProvider>
      <AuthProvider>
        <SessionsProvider>
          <HomeProvider>
            <ParamsCenterProvider>
              <ProfileProvider>
                <FiltersProvider>
                  <LayoutProvider>
                    <BudgetProvider>
                      <KpiProviders>
                        <SettingsProvider>
                          <ParametrizationProvider>
                            <MrpProviders>
                              <AlertsProvider>
                                <OptimizerStorangeProvider>
                                  <OptimizerConfigDefaultProvider>
                                    <DashboardProviders>
                                      <OtbProviders>
                                        <FollowUpFornecedorProvider>
                                          {children}
                                        </FollowUpFornecedorProvider>
                                      </OtbProviders>
                                    </DashboardProviders>
                                  </OptimizerConfigDefaultProvider>
                                </OptimizerStorangeProvider>
                              </AlertsProvider>
                            </MrpProviders>
                          </ParametrizationProvider>
                        </SettingsProvider>
                      </KpiProviders>
                    </BudgetProvider>
                  </LayoutProvider>
                </FiltersProvider>
              </ProfileProvider>
            </ParamsCenterProvider>
          </HomeProvider>
        </SessionsProvider>
      </AuthProvider>
    </UserAuthProvider>
  )
}

export default SharedProvider
